import { render } from "./TopMatter.vue?vue&type=template&id=1e0489fa&scoped=true&ts=true"
import script from "./TopMatter.vue?vue&type=script&lang=ts"
export * from "./TopMatter.vue?vue&type=script&lang=ts"

import "./TopMatter.vue?vue&type=style&index=0&id=1e0489fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0489fa"]])

export default __exports__